import { useState } from 'react'

import {
  Box,
  Button,
  CollapsableCard,
  Icon,
  Item,
  Text,
} from '@factorialco/deprecated-design-system'
import { A3innuvaCompaniesLegalEntitiesFragment } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import { WorkplaceEmployeeGroupFiller } from 'modules/payroll_integrations_a3innuva/components/SettingsSteps/CodeFillers/WorkplaceEmployeeGroupFiller'
import {
  A3InnuvaMapping,
  A3InnuvaWizardData,
  a3InnuvaSourceSchema,
} from 'modules/payroll_integrations_a3innuva/lib/types'

type EmployeeGroup = {
  __typename?: 'EmployeesEmployeeGroup'
  id: number
  name: string
}
interface Props {
  data: A3InnuvaWizardData
  onMappingChanged: (mappings: A3InnuvaMapping[]) => void
  options: Item[]
  legalEntities: A3innuvaCompaniesLegalEntitiesFragment[]
}

export const EmployeeGroupsByLegalEntity = ({
  data,
  onMappingChanged,
  options,
  legalEntities,
}: Props) => {
  const filteredLegalEntities = legalEntities.filter((legalEntity) => {
    if (data.answers['company_code_enabled'] === 'true') {
      return true
    }

    return data.answers[`legal_entity_${legalEntity.id}`]
  })

  const isCardStateOpen = (employeeGroup: EmployeeGroup) => {
    const parsedWorkplaces = a3InnuvaSourceSchema.safeParse(data.answers.workplaces)
    const isClosed = parsedWorkplaces?.data?.mappings?.some(
      (workplace) =>
        workplace.a3innuva_id != undefined && workplace.factorial_id === employeeGroup.id.toString()
    )
    return !isClosed
  }

  const defaultCardsState = () => {
    const defaultStates: Record<string, boolean> = {}

    filteredLegalEntities.forEach((legalEntity) => {
      legalEntity.employeeGroups.forEach((employeeGroup) => {
        defaultStates[legalEntity.id] =
          defaultStates[legalEntity.id] || isCardStateOpen(employeeGroup)
      })
    })
    return defaultStates
  }
  const [openStates, setOpenStates] = useState<Record<string, boolean>>(defaultCardsState())

  const toggleCard = (id: string) => {
    setOpenStates((prev) => ({
      ...prev,
      [id]: !prev[id],
    }))
  }

  return (
    <Box gap="s32">
      <Box gap="s8">
        <Text.Normal>
          {i18n.t(
            'app_store_v2.app_integrations.payroll_integrations_a3innuva.settings.steps.workplace.employee_group_code.description'
          )}
        </Text.Normal>
      </Box>
      {filteredLegalEntities.map(
        (legalEntity: A3innuvaCompaniesLegalEntitiesFragment) =>
          legalEntity.employeeGroups.length > 0 && (
            <Box background="grey200" key={legalEntity.id} borderRadius={{ all: 'abs008' }}>
              <CollapsableCard
                open={openStates[legalEntity.id] ?? false}
                contentBackground="grey000White"
                contentPadding="s0"
                Card={
                  <Box flexDirection="row" justifyContent="spaceBetween">
                    <Box flexDirection="row" gap="s8" alignItems="center">
                      <Icon.Large icon="building" />
                      <Text.Header3>{legalEntity.legalName}</Text.Header3>
                    </Box>
                    <Button
                      iconName={openStates[legalEntity.id] ? 'chevron-up' : 'chevron-down'}
                      onClick={() => toggleCard(legalEntity.id.toString())}
                      type="secondary"
                    />
                  </Box>
                }
                Content={
                  <WorkplaceEmployeeGroupFiller
                    data={data}
                    onMappingChanged={onMappingChanged}
                    options={options}
                    employeeGroups={legalEntity.employeeGroups}
                  />
                }
              />
            </Box>
          )
      )}
    </Box>
  )
}
